module.exports = __webpack_public_path__ + "img/desafios-pista.a8e83330.svg";